import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import { AppView } from 'design-system/AppView';
import { CardView } from 'design-system/CardView';
import BottomPanel from 'design-system/BottomPanel';
import IconBlock from 'design-system/icons/IconBlock';
import { IconEmma } from 'design-system/icons/IconEmma';
import { SettingsItem } from 'design-system/SettingsItem';
import IconToggleOn from 'design-system/icons/IconToggleOn';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SCROLL_INDICATOR_INSETS } from 'design-system/values';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { formatBuyBlock } from '../utils/format';
import BuyBlockModal from '../components/BuyBlockModal';
import { selectTradingAccount } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const BuyBlockScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingBlockExpiryDate = tradingAccount?.account.tradingBlockExpiryDate;
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    const handleBlock = useCallback(() => {
        BuyBlockModal.show();
    }, []);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <ScreenInfoHeader smallSubTitle title="Take a break from trading" subTitle="Emma allows you to temporarily block trading"/>

          <CardView noMarginTop noMarginBottom>
            <SettingsItem title="Turn on a buy block" icon={<IconBlock gradientKey="apricot"/>} description="You can set a buy block on your account for 24 hours. You won’t be able to buy anything on Emma during this time."/>
            <SettingsItem title="You are in control" icon={<IconToggleOn />} description="After 24 hours, you will be unblocked and can resume trading, or enable this feature again if you feel you need more time."/>
            <SettingsItem title="You won’t be blocked from other features" icon={<IconEmma colorKey="brand"/>} description="You will still be able to do all other actions such as sell, deposit and withdraw while this block is active."/>
          </CardView>
        </Animated.ScrollView>
        <BottomPanel>
          {!!tradingBlockExpiryDate && (<>
              <Text centered TextThin-14 Secondary>
                Your buy block expires on {formatBuyBlock(tradingBlockExpiryDate)}
              </Text>
              <Spacer h={16}/>
            </>)}
          <Button brand title={tradingBlockExpiryDate ? 'Extend your block' : 'Turn on block'} onPress={handleBlock}/>
        </BottomPanel>
      </AppView>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: 'Take a break from trading',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default BuyBlockScreen;
